module.exports = __webpack_public_path__ + "media/images/application2/AppEvents__body__dl__item__socials__a--twitter-e6ac288ec32d32faf0632c29a4f32f8b.svg";